module.exports = __webpack_public_path__ + "ed091b887cafb2adbf04a411d7ac40fa.svg";